import { render, staticRenderFns } from "./TeacherChat.vue?vue&type=template&id=698f84cf&scoped=true"
import script from "./TeacherChat.vue?vue&type=script&lang=js"
export * from "./TeacherChat.vue?vue&type=script&lang=js"
import style0 from "./TeacherChat.vue?vue&type=style&index=0&id=698f84cf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698f84cf",
  null
  
)

export default component.exports